export default "__VITE_ASSET__adf4e856__"